<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Copyright</a></p>
<p class="toc sub"><a href="#/front02">Dedication</a></p>
<p class="toc sub"><a href="#/front03">Acknowlegments</a></p>
<p class="toc sub"><a href="#/front04">Photo</a></p>
<p class="toc sub"><a href="#/front05">Introduction</a></p>
<p class="toc"><a href="#/c01">Through the Coloured Glass</a></p>
<p class="toc"><a href="#/c02">Guttin’ Fish</a></p>
<p class="toc"><a href="#/c03">Lizzy’s Prophecy</a></p>
<p class="toc"><span href="#/c04" title="Link target outside of Sample">Partridgeberry Patch</span></p>
<p class="toc"><span href="#/c05" title="Link target outside of Sample">Josie’s Bath</span></p>
<p class="toc"><span href="#/c06" title="Link target outside of Sample">Mrs. Ropson’s Duty</span></p>
<p class="toc"><span href="#/c07" title="Link target outside of Sample">Grieving Nan</span></p>
<p class="toc"><span href="#/c08" title="Link target outside of Sample">Gully Tramp’s Girl</span></p>
<p class="toc"><span href="#/c09" title="Link target outside of Sample">The Reverend’s Pledge</span></p>
<p class="toc"><span href="#/c10" title="Link target outside of Sample">Planting Seeds</span></p>
<p class="toc"><span href="#/c11" title="Link target outside of Sample">A Light of Wood</span></p>
<p class="toc"><span href="#/c12" title="Link target outside of Sample">May Eveleigh’s Threat</span></p>
<p class="toc"><span href="#/c13" title="Link target outside of Sample">The Graduation dance</span></p>
<p class="toc"><span href="#/c14" title="Link target outside of Sample">Kit’s Mark</span></p>
<p class="toc"><span href="#/c15" title="Link target outside of Sample">Broken Birds</span></p>
<p class="toc"><span href="#/c16" title="Link target outside of Sample">The Killing</span></p>
<p class="toc"><span href="#/c17" title="Link target outside of Sample">God’s Law</span></p>
<p class="toc"><span href="#/c18" title="Link target outside of Sample">Tide Against the Wind</span></p>
<p class="toc"><span href="#/c19" title="Link target outside of Sample">Sid’s Stand</span></p>
<p class="toc"><span href="#/c20" title="Link target outside of Sample">Doctor Hodgins’s Waves</span></p>
<p class="toc"><span href="#/c21" title="Link target outside of Sample">Wishing upon a Starfish</span></p>
<p class="toc"><span href="#/c22" title="Link target outside of Sample">The Letter</span></p>
<p class="toc"><span href="#/c23" title="Link target outside of Sample">Godfather’s Cove</span></p>
<p class="toc"><span href="#/c24" title="Link target outside of Sample">Lizzy’s Blessing</span></p>
<p class="toc"><span href="#/c25" title="Link target outside of Sample">Fall from Grace</span></p>
<p class="toc"><span href="#/c26" title="Link target outside of Sample">Loret’s Bargain</span></p>
<p class="toc"><span href="#/c27" title="Link target outside of Sample">Doctor Hodgins’s Promise</span></p>
<p class="toc"><span href="#/c28" title="Link target outside of Sample">Mrs. Ropson’s Plea</span></p>
<p class="toc"><span href="#/c29" title="Link target outside of Sample">Old Joe’s Wish</span></p>
<p class="toc"><span href="#/c30" title="Link target outside of Sample">Kit’s Law</span></p>
<p class="toc"><span href="#/c31" title="Link target outside of Sample">Redemption</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">Back Matter</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">About the Author</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?443bf350